var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDamage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C12 15.7909 10.2091 14 8 14C5.79086 14 4 15.7909 4 18C4 20.2091 5.79086 22 8 22C10.2091 22 12 20.2091 12 18Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.3335C22 7.12436 20.2091 5.3335 18 5.3335C15.7909 5.3335 14 7.12436 14 9.3335C14 11.5426 15.7909 13.3335 18 13.3335C20.2091 13.3335 22 11.5426 22 9.3335Z",
    stroke: "currentColor",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamage);
export default __webpack_public_path__ + "static/media/damage.5c2bb288c9c60f8a2a0fbdf8a016a6c0.svg";
export { ForwardRef as ReactComponent };